import {Template} from '../utils/types';
import {apiClient, FetcherSettings} from './apiClient';
import {dynamicRoute} from './utils';

class ThemeApi {
  ENDPOINTS = {
    getCustomTheme: dynamicRoute({
      regular: (id = '') => `api/v4/branding/templates/${id}/`,
      sdk: (id = '') => `sdk/api/v1/branding/templates/${id}/`,
    }),
  };

  getCustomTheme(id: string, fetcherSettings?: FetcherSettings) {
    return apiClient.get<Template>(this.ENDPOINTS.getCustomTheme(id), fetcherSettings);
  }
}

export {ThemeApi};
